import { createSlice } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer/dist/internal';
import { NotificationActionType, NotificationStateType, NotificationType } from '../../types/notification';

const addNotification = (
    state: WritableDraft<{
        loading: boolean;
        actions: NotificationActionType[] | null;
        notificationsList: NotificationType[];
    }>,
    notification: NotificationType
) => {
    if (notification && !state.notificationsList.filter((item: any): boolean => item._id === notification._id).length) {
        state.notificationsList.unshift(notification);
    }
};

const initialState: NotificationStateType = {
    loading: false,
    actions: null,
    notificationsList: [],
};

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        getNotificationsActionsFetch: (state) => {
            state.loading = true;
        },
        getNotificationsActionsFetchSuccess: (state, action) => {
            state.actions = action.payload;
            state.loading = false;
        },
        getNotificationsActionsFetchFailure: (state, action) => {
            state.actions = null;
            state.loading = false;
        },
        initNotificationsConnection: (state) => {},
        openNotificationsConnection: (state) => {},
        initAllPushNotifications: (state, action) => {
            state.notificationsList = action.payload;
        },
        addPushNotification: (state, action) => {
            if (Array.isArray(action.payload)) {
                action.payload.forEach((notification) => {
                    addNotification(state, notification);
                });
            } else {
                addNotification(state, action.payload);
            }
        },
        deletePushNotification: (state, action) => {
            state.notificationsList = state.notificationsList.filter((item) => item._id !== action.payload);
        },
        closeNotificationsConnection: (state, action) => {
            state.notificationsList = state.notificationsList.filter((item) => item._id !== action.payload);
        },

        deleteNotificationsFetch: (state, action) => {
            state.loading = true;
        },
        deleteNotificationsFetchSuccess: (state, action) => {
            state.notificationsList = state.notificationsList.filter((item) => !action.payload.includes(item._id));
            state.loading = false;
        },
        deleteNotificationsFetchFailure: (state, action) => {
            state.loading = false;
        },
    },
});

export const {
    getNotificationsActionsFetch,
    getNotificationsActionsFetchSuccess,
    getNotificationsActionsFetchFailure,
    initNotificationsConnection,
    initAllPushNotifications,
    addPushNotification,
    deletePushNotification,
    closeNotificationsConnection,
    deleteNotificationsFetch,
    deleteNotificationsFetchSuccess,
    deleteNotificationsFetchFailure,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
